/*eslint-disable react/jsx-key */
import React, { Component } from 'react';
import ReactImageMagnify from 'react-image-magnify';

import TimeLine from './components/Timeline/index';
import MapInfo from './components/MapInfo';
import Gallery from '../Gallery';
import '../Gallery/react-slick.css';
import '../Gallery/app.css';

import Map from '../../../../components/Map';
import Modal from '../../../../components/Modal';
import Button from '../../../../components/Button';
import SidePanel, { SidePanelHeader } from '../../../../components/SidePanel';

import { NF_STATUS, NF_STATUS_TRANSCRIPT } from '../../../../enums/nf-status';

import pictureIconOn from '../../../../assets/images/icon-picture-on.png';
import pictureIconOff from '../../../../assets/images/icon-picture-off.png';
import arrowIcon from '../../../../assets/images/icon-arrow-inside.png';

import './styles.css';
import { downloadFileFromUrl } from '../../../../utils/downlad-url';
import { DISCHARGE_STATUS } from '../../../../constants';
import { Col, Container, Row } from './styles';

export const InvoiceMock = [
  {
    name: 'fake',
    photos: [{ photo: 'https://dummyimage.com/900x1200/000/fff' }],
  },
  {
    name: 'fake',
    photos: [{ photo: 'https://dummyimage.com/900x1200/000/fff' }],
  },
];

class DetailsDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentLatitude: '',
      currentLongitude: '',
      location: '',
      showMapModal: false,
      showGallery: false,
      currentInvoice: null,
    };
  }

  _getStatus = (status) => {
    const statusInt = parseInt(status);

    if (statusInt === DISCHARGE_STATUS.TOTAL_WITH_PICTURE) {
      return {
        title: 'Total',
        color: 'green',
        icon: pictureIconOn,
      };
    }
    if (statusInt === DISCHARGE_STATUS.TOTAL_WITHOUT_PICTURE) {
      return {
        title: 'Total',
        color: 'green',
        icon: pictureIconOff,
      };
    }
    if (statusInt === DISCHARGE_STATUS.PARTIAL_WITH_PICTURE) {
      return {
        title: 'Parcial',
        color: 'yellow',
        icon: pictureIconOn,
      };
    }
    if (statusInt === DISCHARGE_STATUS.PARTIAL_WITHOUT_PICTURE) {
      return {
        title: 'Parcial',
        color: 'yellow',
        icon: pictureIconOff,
      };
    }

    if (statusInt === DISCHARGE_STATUS.DENIED_WITH_PICTURE) {
      return {
        title: 'Recusada',
        color: 'red',
        icon: pictureIconOn,
      };
    }

    if (statusInt === DISCHARGE_STATUS.DENIED_WITHOUT_PICTURE) {
      return {
        title: 'Recusada',
        color: 'red',
        icon: pictureIconOff,
      };
    }
  };

  _openMap = (currentLatitude, currentLongitude, location) =>
    this.setState({
      currentLatitude,
      currentLongitude,
      location,
      showMapModal: true,
    });

  _openGallery = (invoicePhotosArray) => {
    const { currentInvoice } = this.state;

    this.setState(
      {
        showGallery: true,
      },
      () => {
        if (invoicePhotosArray.length > 0 && !currentInvoice) {
          this._getCurrentInvoice(invoicePhotosArray, 0);
        }
      },
    );
  };

  _getCurrentInvoice = (invoicePhotosArray, invoice) => {
    this.setState({
      currentInvoice:
        invoicePhotosArray &&
        invoicePhotosArray[invoice] &&
        invoicePhotosArray[invoice],
    });
  };

  render() {
    const { onDismiss, data } = this.props;

    const {
      id,
      manifestNumber,
      status,
      checkIn,
      finishedAt,
      receivedByLuft,
      issuingSubsidiary,
      driver,
      invoices,
      recipient,
      redelivery,
      appVersion,
      osVersion,
      sender,
      durationOfDischarge,
      transmissionDelay,
    } = data;

    const {
      showMapModal,
      location,
      currentLatitude,
      currentLongitude,
      showGallery,
      currentInvoice,
    } = this.state;

    let invoicePhotosArray = [];

    invoices.filter(el =>
      el.photos &&
        el.photos.filter((photo) => {
          if (photo.photo.length > 0) {
            invoicePhotosArray = [...invoicePhotosArray, photo];
          }
        }));

    const statusData = this._getStatus(status, invoicePhotosArray);

    return (
      <SidePanel>
        <SidePanelHeader title="Detalhes da baixa" onDismiss={onDismiss} />
        <div className="DrawerContainer">
          <Container>
            <Row className="DrawerContainer__row">
              <Col md8>
                <div className="DrawerContainer__subHeader">
                  <div>
                    <h1 className="DrawerContainer__title">{`CTE ${id}`}</h1>
                    <div className="DrawerContainer__manifestId">
                      <img alt="" src={arrowIcon} />
                      <p>
                        <strong>Manifesto: </strong>
                        {manifestNumber}
                      </p>
                    </div>
                  </div>
                  <div className="DrawerContainer__subHeader-picture">
                    <p className="DrawerContainer__subHeader-text">
                      Baixa / Foto
                    </p>
                    <div
                      className={`DrawerContainer__statusBox DrawerContainer__subHeader-status ${statusData.color}`}
                    >
                      {statusData.title}
                    </div>
                    <img alt="" src={statusData.icon} />
                  </div>
                  <div>
                    <p className="DrawerContainer__subHeader-text">{`NFs: ${invoices.length}`}</p>
                  </div>
                </div>
              </Col>
              <Col md4 />
            </Row>
            <Row>
              <Col md4>
                <h1 className="DrawerContainer__subTitle">Baixa</h1>
              </Col>
            </Row>
            <Row className="DrawerContainer__row">
              <Col md8>
                <TimeLine
                  checkIn={checkIn}
                  finishedAt={finishedAt}
                  receivedByLuft={receivedByLuft}
                  stay={durationOfDischarge}
                  transmissionDelay={transmissionDelay}
                />
              </Col>
              <Col>
                <div className="DrawerContainer__borderContainer">
                  <div className="DrawerContainer__infoContainer">
                    <p className="DrawerContainer__itemName light DrawerContainer__recipient-title">
                      Recebedor:
                    </p>
                    <p className="DrawerContainer__itemValue">
                      {invoices[0].receiver}
                    </p>
                  </div>
                  <div className="DrawerContainer__infoContainer recipientImage-container">
                    <div className="DrawerContainer__galleryThumb">
                      <img
                        onClick={() => this._openGallery(invoicePhotosArray)}
                        alt=""
                        src={
                          invoices[0].photos.length > 0
                            ? invoices[0].photos[0].photo
                            : ''
                        }
                      />
                    </div>
                    <div>
                      <p className="DrawerContainer__itemName light">
                        Fotos da baixa
                      </p>
                      <p className="DrawerContainer__itemValue">{`${invoicePhotosArray.length} fotos`}</p>
                    </div>
                  </div>
                  <MapInfo
                    openMap={this._openMap}
                    title="Latitude / Longitude"
                    latitude={recipient.latitude}
                    longitude={recipient.longitude}
                    location="Local da baixa"
                  />
                </div>
              </Col>
            </Row>
            <Row className="DrawerContainer__row">
              <Col md4>
                <h1 className="DrawerContainer__subTitle">
                  Remetente / Destinatário
                </h1>
                <div className="DrawerContainer__borderContainer DrawerContainer__recipientSenderData">
                  <MapInfo
                    title="Filial emissora"
                    openMap={this._openMap}
                    latitude={issuingSubsidiary.latitude}
                    longitude={issuingSubsidiary.longitude}
                    location="Filial emissora"
                    description={issuingSubsidiary.name}
                    noBackgroundColor
                  />
                </div>
                <div className="DrawerContainer__borderContainer DrawerContainer__dataContainer">
                  <div className="DrawerContainer__divideInfo">
                    <p className="DrawerContainer__itemName">Remetente</p>
                    <p className="DrawerContainer__itemValue">{sender}</p>
                  </div>
                  <div>
                    <p className="DrawerContainer__itemName">Destinatário</p>
                    <p className="DrawerContainer__itemValue">
                      {recipient.name}
                    </p>
                  </div>
                  <div>
                    <p className="DrawerContainer__itemName">Endereço</p>
                    <p className="DrawerContainer__itemValue">
                      {recipient.address}
                    </p>
                  </div>
                  <div>
                    <p className="DrawerContainer__itemName">Cidade</p>
                    <p className="DrawerContainer__itemValue">
                      {recipient.city}
                    </p>
                  </div>
                  <div>
                    <p className="DrawerContainer__itemName">Estado</p>
                    <p className="DrawerContainer__itemValue">
                      {recipient.state}
                    </p>
                  </div>
                  <div
                    className={
                      redelivery && Object.keys(redelivery).length > 0
                        ? 'DrawerContainer__divideInfo'
                        : ''
                    }
                  >
                    <MapInfo
                      openMap={this._openMap}
                      title="Latitude / Longitude"
                      latitude={recipient.latitude}
                      longitude={recipient.longitude}
                      location="Destinatário"
                    />
                  </div>
                  {redelivery && Object.keys(redelivery).length > 0 && (
                    <React.Fragment>
                      <div>
                        <p className="DrawerContainer__itemName">
                          Endereço de redespacho
                        </p>
                        <p className="DrawerContainer__itemValue">
                          {redelivery && redelivery.redeliveryAddress}
                        </p>
                      </div>
                      <div>
                        <p className="DrawerContainer__itemName">Cidade</p>
                        <p className="DrawerContainer__itemValue">
                          {redelivery && redelivery.redeliveryCity}
                        </p>
                      </div>
                      <MapInfo
                        openMap={this._openMap}
                        title="Latitude / Longitude"
                        latitude={redelivery && redelivery.redeliveryLatitude}
                        longitude={redelivery && redelivery.redeliveryLongitude}
                        location="Destinatário"
                      />
                    </React.Fragment>
                  )}
                </div>
              </Col>
              <Col md4>
                <h1 className="DrawerContainer__subTitle">Transporte</h1>
                <div className="DrawerContainer__borderContainer DrawerContainer__dataContainer">
                  <div>
                    <p className="DrawerContainer__itemName">
                      Nome do motorista
                    </p>
                    <p className="DrawerContainer__itemValue">
                      {driver.name ? driver.name : 'não preenchido'}
                    </p>
                  </div>
                  <div className="DrawerContainer__divideInfo">
                    <p className="DrawerContainer__itemName">Celular</p>
                    <p className="DrawerContainer__itemValue">
                      {driver.cellphone ? driver.cellphone : 'não preenchido'}
                    </p>
                  </div>
                  <div>
                    <p className="DrawerContainer__itemName">
                      Tracker do caminhão
                    </p>
                    <p className="DrawerContainer__itemValue">
                      {driver.truckTracker
                        ? driver.truckTracker
                        : 'não preenchido'}
                    </p>
                  </div>
                  <div>
                    <p className="DrawerContainer__itemName">
                      Placa do caminhão
                    </p>
                    <p className="DrawerContainer__itemValue">
                      {driver.truckPlate ? driver.truckPlate : 'não preenchido'}
                    </p>
                  </div>
                  <div>
                    <p className="DrawerContainer__itemName">
                      Tipo do caminhão
                    </p>
                    <p className="DrawerContainer__itemValue">
                      {driver.truckType ? driver.truckType : 'não preenchido'}
                    </p>
                  </div>
                  <div>
                    <p className="DrawerContainer__itemName">
                      Marca do caminhão
                    </p>
                    <p className="DrawerContainer__itemValue">
                      {driver.truckBrand ? driver.truckBrand : 'não preenchido'}
                    </p>
                  </div>
                  <div className="DrawerContainer__divideInfo">
                    <p className="DrawerContainer__itemName">
                      Modelo do caminhão
                    </p>
                    <p className="DrawerContainer__itemValue">
                      {driver.truckModel ? driver.truckModel : 'não preenchido'}
                    </p>
                  </div>
                  <div>
                    <p className="DrawerContainer__itemName">
                      Tipo da carroceria
                    </p>
                    <p className="DrawerContainer__itemValue">
                      {driver.bodyworkType
                        ? driver.bodyworkType
                        : 'não preenchido'}
                    </p>
                  </div>
                  <div>
                    <p className="DrawerContainer__itemName">
                      Modelo da carroceria
                    </p>
                    <p className="DrawerContainer__itemValue">
                      {driver.bodyworkModel
                        ? driver.bodyworkModel
                        : 'não preenchido'}
                    </p>
                  </div>
                  <div className="DrawerContainer__divideInfo">
                    <p className="DrawerContainer__itemName">
                      Marca da carroceria
                    </p>
                    <p className="DrawerContainer__itemValue">
                      {driver.bodyworkBrand
                        ? driver.bodyworkBrand
                        : 'não preenchido'}
                    </p>
                  </div>
                  <div>
                    <p className="DrawerContainer__itemName">Versão do app</p>
                    <p className="DrawerContainer__itemValue">
                      {appVersion || 'não preenchido'}
                    </p>
                  </div>
                  <div className="DrawerContainer__infoLastItem">
                    <p className="DrawerContainer__itemName">
                      Versão do Android
                    </p>
                    <p className="DrawerContainer__itemValue">
                      {osVersion || 'não preenchido'}
                    </p>
                  </div>
                </div>
              </Col>
              <Col md4>
                <h1 className="DrawerContainer__subTitle">Notas fiscais</h1>
                {invoices.map(el => (
                  <div className="DrawerContainer__NFDetail">
                    <div
                      className={`DrawerContainer__statusBox ${
                        el.status === NF_STATUS.DOWNLOADED ? 'green' : 'red'
                      }`}
                    >
                      {NF_STATUS_TRANSCRIPT[el.status]}
                    </div>
                    <p className="DrawerContainer__itemValue">{el.id}</p>
                    <img
                      alt=""
                      src={
                        el.photos.length > 0 ? pictureIconOn : pictureIconOff
                      }
                    />
                  </div>
                ))}
              </Col>
            </Row>
          </Container>
          {showMapModal ? (
            <Modal
              title={location}
              onBackdropClick={() => this.setState({ showMapModal: false })}
            >
              <Map
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDNV7mHyjuTm0VC8ZZnW90OTZWrvBnXIaw&v=3.exp&libraries=geometry,drawing,places"
                loadingElement={
                  <div className="ManifestsInTransit-Ctes__loading-el" />
                }
                latitude={currentLatitude}
                longitude={currentLongitude}
                containerElement={
                  <div className="ManifestsInTransit-Ctes__container-el" />
                }
                mapElement={<div className="ManifestsInTransit-Ctes__map-el" />}
                isKeyAccount={false}
                shippingGroupId={1}
                performanceStatusCode={1}
                defaultZoom={15}
              />
            </Modal>
          ) : null}
          {invoicePhotosArray.length > 0 && showGallery ? (
            <SidePanel overlay>
              <SidePanelHeader
                title="Fotos e comprovantes"
                onDismiss={() => this.setState({ showGallery: false })}
              />
              <div
                className="fluid react-slick"
                style={{
                  width: '100%',
                  margin: '32px 0',
                  maxHeight: '70vh',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <div
                  style={{
                    flex: '0 0 50%',
                    margin: '20px 0 20px 20px',
                  }}
                >
                  <Gallery
                    listLength={invoicePhotosArray.length}
                    getCurrentInvoice={current =>
                      this._getCurrentInvoice(invoicePhotosArray, current)
                    }
                  >
                    {invoicePhotosArray.map(el => (
                      <ReactImageMagnify
                        {...{
                          smallImage: {
                            isFluidWidth: true,
                            src: el.photo,
                          },
                          largeImage: {
                            src: el.photo,
                            width: 1426,
                            height: 2000,
                          },
                          enlargedImagePosition: 'over',
                        }}
                      />
                    ))}
                  </Gallery>
                  <div className="DrawerContainer__galleryButtonContainer">
                    <Button
                      skin="primary"
                      text="Baixar esta foto"
                      icon="download"
                      onClick={() => {
                        downloadFileFromUrl(
                          `invoice-${currentInvoice.id}.jpg`,
                          currentInvoice.photo,
                        );
                      }}
                    />
                    <Button
                      skin="primary"
                      text="Baixar todas"
                      icon="download"
                      onClick={() => {
                        invoices.filter(el =>
                            el.photos &&
                            el.photos.filter((photo) => {
                              downloadFileFromUrl(
                                `invoice-${photo.id}.jpg`,
                                photo.photo,
                              );
                            }));
                      }}
                    />
                  </div>
                </div>
              </div>
            </SidePanel>
          ) : null}
        </div>
      </SidePanel>
    );
  }
}

export default DetailsDrawer;
